import { ApiService } from "../..";

export const bindMobile = (sms: {
  phoneNumber: string;
  code: string;
  bizId: string;
}) => {
  return ApiService.baseAction(
    "auth/bind_mobile",
    {
      data: { sms },
    },
    "post"
  );
};
